export default __webpack_public_path__ + "static/media/system_builder_molecule_panel.a770e902.png";